import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Sides from "../Plugins/Sides";
import logout from "../Controllers/Auth/Api/Logout";
import { Search,FileText,Users,Briefcase,User,MessageCircle,HelpCircle,Bell,Book,Home,
    MessageSquare,DownloadCloud,LogOut,Grid,Star } from 'react-feather';
import getUnReadMessage from "../Controllers/Dashboard/Api/getUnReadMessage";
import Password from "../Controllers/Dashboard/Password";
import {MCbrowser} from "../Context/browserContext";
import Loader from "react-loader-spinner";

class MainSideBar extends Component{

    constructor(props) {
        super(props);
        this.handleLogout = this.logoutUp.bind(this);
        this.HpicChanged = this.picChanged.bind(this);

        this.state = { render:false,displayLogout:false};
        this.messages=null;
        this.messageNums=null;
        this.userImgRef=React.createRef();
        this.userImgRef2=React.createRef();

        this.props=props;
    }

    refresh() {
        let r=!this.state.render;
        this.setState({ render: r });
    }

    async logoutUp() {
        await this.setState({displayLogout: true});
        let l= await logout();
        if(l===true){
            let page = this.context.page;
            let obj={command:"close",data:{}};
            await page.pageBC.Hsend(obj);
            page.pageBC.Hleave();
            this.setState({isLogout: true});
            this.props.logout();
        }
    }


    async unReadMessage() {
        let res= await  getUnReadMessage();
        if( this.isAlive ){
            if (res !== false) {
                if (res.hasOwnProperty("data")) {
                    let data = res.data;
                    if (res.hasOwnProperty("nums")) {
                        if(res.nums>0){
                            this.messageNums =  <span className="badge badge-info badge-counter">{res.nums}</span>;
                        }else{
                            this.messageNums = null;
                        }
                        this.messages=[];
                        let idn=0;
                        let l=data.length;
                        for (let i=0;i<l;i++) {
                            idn++;
                            let el =  <a className="dropdown-item d-flex align-items-center" href="#" key={idn}>
                                        <div className="mr-3">
                                            <div className="icon-circle bg-primary">
                                                <DownloadCloud color="white" size={14}  />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="small text-gray-500">
                                                2 آبان 1400
                                            </div>
                                            <span className="font-weight-bold">
                                             {data[i].title}
                                          </span>
                                        </div>
                                    </a> ;
                            this.messages.push(el);
                        }
                        this.refresh();
                    }
                }
            }
        }
    }

    picChanged(){
        let d1=new Date().getTime();
        this.userImgRef2.current.src = "http://mdyaran.ir/membership/picture?" + d1;
        this.userImgRef.current.src = "http://mdyaran.ir/membership/picture?" + d1;
    }

    componentDidMount() {
        let page = this.context.page;
        page.dispatcher.add("route", "profilePic","changed",this.HpicChanged);
        this.unReadMessage();
    }

    render() {
        let c1="logout-backdrop fade ";
        if(this.state.displayLogout) c1="logout-backdrop fade show";

        let kartabl=null;
        if(this.context.memberObj.isShora) {
            kartabl =  <li className="nav-item dropdown mr-2">
                <a className="nav-link dropdown-toggle pr-0" href="#" role="button"
                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <FileText className=" mr-2"size={14} />
                    <span className="d-none d-lg-inline">
                              کارتابل
                          </span>
                </a>
                <div className="dropdown-menu dropdown-menu-right shadow-sm">
                    <Link className="dropdown-item" to="/membership/topics">
                        <Briefcase className=" mr-1" size={14} />
                          موضوعات
                    </Link>
                    <Link className="dropdown-item" to="/membership/mosavabats">
                        <Briefcase className=" mr-1" size={14} />
                        لیست مصوبات جلسات
                    </Link>
                    <Link className="dropdown-item" to="/membership/mosavabat/insert">
                        <FileText className=" mr-2" size={14}/>
                        ثبت مصوبه جلسه

                    </Link>
                </div>
            </li>;
        }

        return (
            <React.Fragment>
                <nav className="navbar navbar-expand navbar-dark bg-dark osahan-nav-top p-0 navbar1">
                    <div className="container  ">
                        <Link className="navbar-brand ml-2" to="/membership">
                            <img src="/svg/logo.svg" alt="" />
                        </Link>
                        <form
                            className="d-none d-md-inline-block form-inline ml-auto my-2 my-md-0 mw-100 navbar-search">
                            <div className="input-group  ">
                                <input type="text" className="form-control shadow-none border-0"
                                       placeholder="جستجو اعضاء و مطالب و پروژه ها و..." aria-label="Search"
                                       aria-describedby="basic-addon2" />
                                    <div className="input-group-append">
                                        <button className="btn" type="button">
                                            <Search size={12} />
                                        </button>
                                    </div>
                            </div>
                        </form>
                        <ul className="navbar-nav mr-auto d-flex align-items-center">
                            <li className="nav-item dropdown no-arrow d-md-none">
                                <a className="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button"
                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <Search className="ml-2" size={14}/>
                                </a>
                                <div className="dropdown-menu dropdown-menu-right p-3 shadow-sm animated--grow-in" aria-labelledby="searchDropdown">
                                    <form className="form-inline mr-auto w-100 navbar-search">
                                        <div className="input-group w-100">
                                            <input type="text" className="form-control border-0 shadow-none"
                                                   placeholder="جستجو اعضاء و مطالب و ..."  aria-label="Search"
                                                   aria-describedby="basic-addon2" />
                                                <div className="input-group-append">
                                                    <button className="btn" type="button">
                                                        <Search size={14}  />
                                                    </button>
                                                </div>
                                        </div>
                                    </form>
                                </div>
                            </li>
                            <Sides />
                            <li className="nav-item d-none d-sm-inline">
                                <Link className="nav-link" to="/membership/moshkelat/insert">
                                    <FileText className=" ml-2" size={14} />
                                    <span className="d-none d-md-inline">

                                        صدای مردم
                                  </span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/membership/connection" className="nav-link"  >
                                    <Users className=" ml-2" size={14}/>
                                    <span className="d-none d-lg-inline">
                                          دوستان
                                      </span>
                                </Link>
                            </li>
                            {kartabl}
                            <li className="nav-item dropdown mr-2">
                                <a className="nav-link dropdown-toggle pr-0" href="#" role="button"
                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <FileText className=" mr-2" size={14} />
                                    <span className="d-none d-lg-inline">
                              صفحات
                          </span>
                                </a>
                                <div className="dropdown-menu text-right  shadow-sm">
                                    <Link className="dropdown-item" to="/membership/moshkelats">
                                        <Briefcase className=" ml-1" size={14} />
                                          صدای مردم
                                    </Link>
                                    <Link className="dropdown-item" to="/membership/moshkelat/insert">
                                        <FileText className=" ml-2" size={14}/>
                                        ثبت
                                          صدای مردم

                                    </Link>
                                    <Link className="dropdown-item" to="/membership/profile">
                                        <User className=" ml-1" size={14} />
                                        پروفایل
                                    </Link>
                                    <Link to="/membership/connection" className="dropdown-item">
                                        <Users className=" ml-1" size={14} />
                                        دوستان
                                    </Link>
                                    <Link to="/membership/message" className="dropdown-item">
                                        <Bell className=" mr-1" size={14} />
                                        اطلاعیه ها
                                    </Link>
                                    <a className="dropdown-item" target="_blank" href="http://mdyaran.ir/راهنمای-سامانه">
                                        <HelpCircle className=" ml-1"  size={14} />
                                        راهنمای سامانه
                                    </a>
                                    <a className="dropdown-item" target="_blank" href="http://mdyaran.ir/مقررات">
                                        <Book className=" ml-1" size={14} />
                                        مقررات
                                    </a>
                                    <a className="dropdown-item" target="_blank" href="http://mdyaran.ir">
                                        <Home className=" ml-1" size={14} />
                                        صفحه نخست
                                    </a>
                                </div>
                            </li>
                            <li className="nav-item dropdown no-arrow mx-1 osahan-list-dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown"
                                   aria-haspopup="true" aria-expanded="false">
                                    <Bell size={14} />
                                    {this.messageNums}
                                </a>
                                <div className="dropdown-list dropdown-menu text-right  shadow-sm">
                                    <h6 className="dropdown-header">
                                        اطلاعیه
                                    </h6>
                                    {this.messages}
                                    <Link to="/membership/message" className="dropdown-item text-center small text-gray-500 ">
                                       همه را ببین
                                    </Link>
                                </div>
                            </li>
                            <li className="nav-item dropdown no-arrow ml-1 osahan-profile-dropdown">
                                <a className="nav-link dropdown-toggle pr-0" href="#" role="button"
                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img className="lazyload blur-up img-profile rounded-circle mw30 " ref={this.userImgRef2}
                                         src="/images/avatar.jpg" data-src="http://mdyaran.ir/membership/picture" />
                                </a>
                                <div className="dropdown-menu  text-right shadow-sm">
                                    <div className="p-3 d-flex align-items-center">
                                        <div className="dropdown-list-image ml-3">
                                            <img ref={this.userImgRef} className="lazyload blur-up rounded-circle mw40"
                                                 src="/images/avatar.jpg" data-src="http://mdyaran.ir/membership/picture" alt=""/>
                                            <div className="status-indicator bg-success"/>
                                        </div>
                                        <div className="font-weight-bold">
                                            <div className="text-truncate">
                                                {this.context.memberObj.firstName}
                                                &nbsp;
                                                {this.context.memberObj.lastName}
                                            </div>
                                            <div className="small text-gray-500">
                                                {this.context.memberObj.username}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dropdown-divider"/>
                                        <Link to="/membership/profile" className="dropdown-item ">
                                            <User className="ml-1" size={14} />
                                            پروفایل
                                        </Link>

                                        <button type="button" className="dropdown-item " data-toggle="modal" data-target="#passwordModal" >
                                            <Star className="ml-1" size={14} />
                                            تغییر گذرواژه
                                        </button>
                                    <div className="dropdown-divider"/>
                                    <Link to="/membership" className="dropdown-item ">
                                        <Grid className="ml-1" size={14} />
                                        ناحیه کاربری
                                    </Link>
                                    <button   onClick={this.handleLogout} className="dropdown-item">
                                        <LogOut className="ml-1" size={14}/>
                                        خروج
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div className={c1}>
                    <div className="model-div">
                        <div className="model-div-body text-center d-block">
                            <Loader type="Oval"  color="#FFFFFF" height={30}  width={30}    />
                            <div className="text-white font-10 mt-3 mb-3 line-heigh-2 position-relative">
                                خروج از ناحیه کاربری ...
                            </div>
                        </div>
                    </div>
                </div>
                <Password />
            </React.Fragment>
        );
    }

    componentWillUnmount() {
        window.removeEventListener('resize',this.onScroll);
    }
}

MainSideBar.contextType = MCbrowser;

export default MainSideBar;
